import React from 'react';

const MarkdownList = ({ findings }) => {
  if (!findings || !findings.files) return null;

  return (
    <div className="text-left">
      <h3 className="text-lg font-semibold text-white mb-6 flex items-center">
        Optimized Markdown Files
      </h3>
      
      <div className="overflow-x-auto rounded-lg border border-dark-700 bg-dark-900/50">
        <table className="min-w-full divide-y divide-dark-700">
          <thead className="bg-dark-900">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-bold text-dark-400 uppercase tracking-widest">File Path</th>
              <th className="px-4 py-3 text-left text-xs font-bold text-dark-400 uppercase tracking-widest">Status</th>
              <th className="px-4 py-3 text-left text-xs font-bold text-dark-400 uppercase tracking-widest">Bot Access</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-dark-800">
            {findings.files.map((file) => (
              <tr key={file.path} className="hover:bg-dark-750 transition-colors group">
                <td className="px-4 py-4 whitespace-nowrap text-sm font-medium text-dark-100 group-hover:text-white">
                  {file.path}
                </td>
                <td className="px-4 py-4 whitespace-nowrap text-sm">
                  {file.status === 'found' ? (
                    <span className="inline-flex items-center text-green-400 font-medium bg-green-500/10 px-2.5 py-0.5 rounded border border-green-500/20">
                      <span className="mr-2">✅</span> Found
                    </span>
                  ) : (
                    <span className="inline-flex items-center text-red-400 font-medium bg-red-500/10 px-2.5 py-0.5 rounded border border-red-500/20">
                      <span className="mr-2">❌</span> Missing
                    </span>
                  )}
                </td>
                <td className="px-4 py-4 whitespace-nowrap text-sm">
                  {file.status === 'found' ? (
                    file.accessible ? (
                      <span className="inline-flex items-center text-green-400 font-medium bg-green-500/10 px-2.5 py-0.5 rounded border border-green-500/20">
                        <span className="mr-2">✅</span> Accessible
                      </span>
                    ) : (
                      <span className="inline-flex items-center text-yellow-400 font-medium bg-yellow-500/10 px-2.5 py-0.5 rounded border border-yellow-500/20">
                        <span className="mr-2">⚠️</span> Blocked
                      </span>
                    )
                  ) : (
                    <span className="text-dark-600">-</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MarkdownList;
